module.exports = prestashop;


/*****************
 ** WEBPACK FOOTER
 ** external "prestashop"
 ** module id = 56
 ** module chunks = 0
 **/